import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { H3 } from './Heading';
import Text from './Text';

const EmptyStateWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;
  justify-content: center;
  max-width: 70%;
  text-align: center;
`;

const Headline = styled(H3)`
  color: var(--pleather);
  margin-bottom: -5px;
`;

const Content = styled(Text)`
  color: var(--pleather);
`;

export const EmptyState = ({ action, children, headline, image }) => (
  <EmptyStateWrapper>
    <ContentWrapper>
      {image}
      {headline && <Headline>{headline}</Headline>}
      <Content>{children}</Content>
      {action}
    </ContentWrapper>
  </EmptyStateWrapper>
);

EmptyState.propTypes = {
  action: PropTypes.node,
  children: PropTypes.string.isRequired,
  headline: PropTypes.string,
  image: PropTypes.node.isRequired,
};

export default styled(EmptyState)``;
